import {NoteActionButton} from '../../../modules/notes/NoteActionButton'
import * as models from '../../../modules/workflow/models'
import {Task} from '../../../modules/workflow/task/WorkflowTaskStore'
import React from 'react'
const mod = angular.module('clientDashboardApp')


mod.value('NoteActionButton', NoteActionButton)


function NoteButton({entityId, provider, noteType}) {

  return <NoteActionButton
    filters={provider ? [provider] : []}
    entityId={entityId}
    noteType={noteType || 'Listings'}
    button={({isLoading, notes}) => {
      return <button className="btn btn-secondary btn-sm d-inline-flex align-items-center">
        <span className="fas fa-comment-edit d-flex mr-1" /> Notes {
          notes.length ?
          <span className="badge badge-pill badge-secondary ml-1 btn-badge">{notes.length}</span>
          : undefined
        }
      </button>
    }}
  />
}

mod.value('NoteButton', NoteButton)
mod.directive('listingActionToolbar', () => {
  return {
    restrict: 'E',
    scope: {
      locationId: '=',
      listing: '=',
      provider: '=',
      noteType: '=',
      workflowTaskType: '@',
      includeChangeUrl: '='
    },
    template: `
      <div className="btn-group">
        <react-component name="NoteButton" props="noteProps"></react-component>
        <react-component name="EntityTaskTypeButton" props="workflowTaskProps"></react-component>
        <button class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center mt-2" ng-if="includeChangeUrl" ng-click="openModal()">
          <span class="ss ss-link d-flex mr-1"></span> Add URL
        </button>
      </div>
    `,
    controller: ($scope, $uibModal) => {
      function getLocationId() {
        return $scope.listing ? $scope.listing.locationId : $scope.locationId.replace(/^legacy-/, '')
      }

      function getProvider() {
        return $scope.listing ? $scope.listing.contentProvider : $scope.provider
      }

      function entityIdFromListing() {
        return $scope.listing ? `${$scope.listing.locationId}/${$scope.listing.contentProvider}` : `${$scope.locationId.replace(/^legacy-/, '')}/${$scope.provider}`
      }


      $scope.noteProps = {
        provider: $scope.provider,
        entityId: entityIdFromListing(),
        noteType: $scope.noteType,
      }
      $scope.getNoteProps = () => {
        return noteProps
      }

      const tt = models.getTaskType($scope.workflowTaskType) || models.getTaskType('UpdateListingDetails')

      $scope.wfTask = () => {
        return Task({
          entityId: entityIdFromListing(),
          entityType: 'LocationAndProvider',
          taskType: tt.value,
          taskName: tt.name,
          locationId: $scope.listing ? $scope.listing.locationId : $scope.locationId.replace(/^legacy-/, '')
        })
      }

      $scope.workflowTaskProps = {
        entityId: entityIdFromListing(),
        entityType: 'LocationAndProvider',
        entityData: { listing: $scope.listing },
        entityTaskTypes: [tt],
        // placement
        newTask: $scope.wfTask,
        trigger: <button className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"><span className="fas fa-check-square d-flex mr-1" /> Tasks</button>
      }

      $scope.openModal = function () {
        $uibModal.open({
          template: require('../listingEditor.html'),
          controller: 'ListingEditorCtrl',
          size: 'lg',
          resolve: {
            listingOptions: function () {
              return {
                locationId: getLocationId(),
                provider: getProvider()
              };
            },
          }
        });

      }


    }
  }
})
